import { render, staticRenderFns } from "./ViewerComponent.vue?vue&type=template&id=6b3c5806&scoped=true&"
import script from "./ViewerComponent.vue?vue&type=script&lang=js&"
export * from "./ViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ViewerComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ViewerComponent.vue?vue&type=style&index=1&id=6b3c5806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3c5806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins\\workspace\\Apps\\WebViewer\\Dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6b3c5806', component.options)
    } else {
      api.reload('6b3c5806', component.options)
    }
    module.hot.accept("./ViewerComponent.vue?vue&type=template&id=6b3c5806&scoped=true&", function () {
      api.rerender('6b3c5806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\viewer\\components\\ViewerComponent.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/viewer/components/ViewerComponent.vue
// module id = 300
// module chunks = 0